import React, { useState } from 'react'
import Checkbox from 'react-custom-checkbox';
import { FiCheck } from 'react-icons/fi';

const CheckboxColored = ({ check, handleChange, name, label,  }) => {
  const [state, setstate] = useState([check]);
  const [boolia, setBoolia] = useState(false);

  return (
    <div>
      <Checkbox
        icon={<FiCheck color="#28BAD8" size={24} />}
        onChange={(value) => {
          setBoolia(value);
          let p = {
            name: `${name}`,
            value: value,
            
            
          }
          handleChange(p);
        }}
        className="checkbox_JobForm"
        borderColor={boolia ? "#28BAD8" : "#707070"}
        style={{ cursor: "pointer" }}
        labelStyle={{ marginLeft: 5, userSelect: "none" }}
        label={label}
      />
    </div>
  );
};

export default CheckboxColored
